export const AIR_RECEPTIONIST_MOCK_ID = '00000000-0000-0000-0000-000000000000';

export const TASK_HIGHLIGHT_DURATION = 3000;
